import 'slick-carousel';

class Slider {
    constructor(elem) {
        this.elem = elem;
        this.$slider = $(this.elem).find('.slider__slider-wrapper');
        this.breakpoints = {
            'screen-sm': 576,
            'screen-md': 768,
            'screen-lg': 992,
            'screen-xl': 1260,
        };
    }

    init() {
        if ($(this.elem).find('.slider__item').length) {
            const buttonNextText = $(this.elem).data('slider-button-next');
            const buttonPrevText = $(this.elem).data('slider-button-prev');
            const settings = {
                accessibility: true,
                dots: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                prevArrow: `<button class="slick-prev slick-arrow" type="button">${buttonPrevText}</button>`,
                nextArrow: `<button class="slick-next slick-arrow" type="button">${buttonNextText}</button>`,
            };

            if ($(this.elem).hasClass('slider--auto-size')) {
                settings.variableWidth = true;

                // this.$slider.on('init', () => {
                //     this.autosizeSlider();
                // });
                // $(window).on('resize orientationchange', () => {
                //     this.autosizeSlider();
                // });
            }

            // if ($(this.elem).hasClass('slider--center-mode')) {
            //     settings.centerMode = true;
            // }

            $(window).on('resize orientationchange', () => {
                this.$slider.slick('resize');
            });

            this.$slider.slick(settings);
        }
    }

    autosizeSlider() {
        let isDesktop = false;

        if (window.matchMedia(`(min-width: ${this.breakpoints['screen-md']}px)`).matches) {
            isDesktop = true;
        }

        this.$slider.find('.slick-slide').each((iterator, element) => {
            if (isDesktop) {
                $(element).width($(element).find('img').width());
            } else {
                $(element).width(this.$slider.width());
            }
        });
    }
}

export default Slider;
